import type { PropsWithChildren, SVGAttributes } from "react";
import { AnimatedLogo } from "src/components/AnimatedLogo/AnimatedLogo.tsx";
import { AnimatePresence, type HTMLMotionProps, motion } from "framer-motion";
import * as styles from "./LoadingOverlay.style.tsx";
import { H3 } from "src/components/HeadingV2/HeadingV2.tsx";

const Title = ({ children }: PropsWithChildren) => {
  return (
    <div css={styles.title}>
      <H3>{children}</H3>
    </div>
  );
};

const Spinner = (props: SVGAttributes<SVGElement>) => {
  return <AnimatedLogo {...props} />;
};

const Root = ({
  isLoading,
  children,
  ...restProps
}: PropsWithChildren<
  {
    isLoading: boolean;
  } & HTMLMotionProps<"div">
>) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          css={styles.root}
          {...restProps}
        >
          <div css={styles.backDrop} />
          <div css={styles.inner}>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const LoadingOverlay = Object.assign(Root, {
  Root,
  Title,
  Spinner,
});
